import { render, staticRenderFns } from "./SceneChooser.vue?vue&type=template&id=72cc246b&scoped=true&"
import script from "./SceneChooser.vue?vue&type=script&lang=js&"
export * from "./SceneChooser.vue?vue&type=script&lang=js&"
import style0 from "./SceneChooser.vue?vue&type=style&index=0&id=72cc246b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc246b",
  null
  
)

component.options.__file = "SceneChooser.vue"
export default component.exports